import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_cbq5b5q6t2: FaireBrandEntity = {
  token: "b_cbq5b5q6t2",
  type: "brand",
  name: "Mañana Hot Sauce",
  avatarUrl:
    "https://cdn.faire.com/fastly/4f34423ff62585c3bd9bc73166c88ac9a13a80dc7b5bc71cf734cdc8f7806d35.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/dc09870026c7056dad05801242a8aaef57e1f2db94a3455488b34bf062d437e3.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/4f34423ff62585c3bd9bc73166c88ac9a13a80dc7b5bc71cf734cdc8f7806d35.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/dc09870026c7056dad05801242a8aaef57e1f2db94a3455488b34bf062d437e3.jpeg",
  location: "Miami, FL, USA",
  minimumOrderDollars: 24,
  rating: 5,
  reviewCount: 2,
  isInsider: true,
  description:
    "Mañana is a vegan + keto alternative to other sauces which often contain preservatives, additives, sugars, artificial flavors and seed oils.\n\nMañana began in small batches in Miami. Customers loved it, so I continued making it. 5/10 spice level.\n\nMañana is a sauce for people with a romantic and optimistic worldview, a.k.a our motto printed on the bottle: \"For old souls.'  With that being said, it can still be enjoyed by everyone. \n\nNo Preservatives | Vegan | Zero Added Sugar | Keto | No Seed Oils | Gluten Free",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:31.118Z",
    importedBy: "entity-db-cli",
  },
};
